import ApiService from '@/common/api.service'

const RESOURCE = 'line'
const LineService = {
  OAuth (params) {
    return ApiService.post(`${RESOURCE}/oauth`, params)
  },
  OAuthTop (params) {
    return ApiService.post(`${RESOURCE}/oauth/top`, params)
  },
  lineRegistration (params) {
    return ApiService.post(`${RESOURCE}/regist`, params)
  },
  lineProfileRegistration (params) {
    return ApiService.post(`${RESOURCE}/profile/regist`, params)
  },
  lineNoProfileRegistration (params) {
    return ApiService.post(`${RESOURCE}/no_profile/regist`, params)
  },
  lineLiffProfileRegistration (params) {
    return ApiService.post(`${RESOURCE}/liff/profile/regist`, params)
  },
  lineLiffNoProfileRegistration (params) {
    return ApiService.post(`${RESOURCE}/liff/no_profile/regist`, params)
  },
  lineTopRegistration (params) {
    return ApiService.post(`${RESOURCE}/top/regist`, params)
  }
}
export default LineService
